module.exports = __webpack_public_path__ + "img/vertical_2_1_8017.f719ef8e.png";